import { TranslateService } from "@ngx-translate/core";
import { Injectable, Inject } from '@angular/core';
import { bookingStatusList } from 'src/app/components/common/static-data-common';
import { NgbDate } from "@ng-bootstrap/ng-bootstrap";
import * as CryptoJS from 'crypto-js';
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: 'root' })

export class UtilityService {
  public langSubject = new BehaviorSubject<string>(localStorage.getItem('lang') || 'en');
  public currentUserSubject = new BehaviorSubject<string>(localStorage.getItem('currentUser'));

  constructor(private translate: TranslateService) {

  }

  setLangSubject(value: string) {
    this.langSubject.next(value);
  }

  setCurrentUser(value: string) {
    this.currentUserSubject.next(value);
  }
  // check the booking status limit based on the status id.
  checkBookingStatus(statusId: number): boolean {
    return bookingStatusList.filter(x => x.id == statusId).length > 0;
  }
  // localization translate text if we have to used in ts file
  textTranslate(textTrans: string) {
    let tradMessage: string = "";
    this.translate.get(textTrans).subscribe((text: string) => { tradMessage = text });
    return tradMessage;
  }

  getContainerList(limit) {

    var containerMasterList = [];
    for (let index = 1; index <= limit; index++) {
      containerMasterList.push({ "id": index, "name": "container - " + index });
    }
    return containerMasterList;
  }

  //get the list of dates within a range
  getDatesBetweenDateRange(startDate: NgbDate, endDate: NgbDate) {
    let dates = [];
    //to avoid modifying the original date
    const theDate = new Date(startDate.year, startDate.month, startDate.day);
    const theEndDate = new Date(endDate.year, endDate.month, endDate.day);
    while (theDate <= theEndDate) {
      dates = [...dates, new Date(theDate).toString()]
      theDate.setDate(theDate.getDate() + 1)
    }
    return dates;
  }
  //numeric validation for maxItems
  numericValidation(event, length) {
    var invalidChars = [
      "-",
      "+",
      "e",
      "E"
    ];
    if (invalidChars.includes(event.key) || event.target.value.length >= length)
      event.preventDefault();
  }

  getEntityName(): string {
    var entityName = localStorage.getItem('_entity');
    // var key = CryptoJS.enc.Utf8.parse('1234567891012345');
    // var iv = CryptoJS.enc.Utf8.parse('1234567891012345');

    // if(localStorage.getItem('_entity'))
    // {
    //     entityName = CryptoJS.AES.decrypt(localStorage.getItem('_entity'),key, {
    //     keySize: 128 / 8,
    //     iv: iv,
    //     mode: CryptoJS.mode.CBC,
    //     padding: CryptoJS.pad.Pkcs7
    // }).toString(CryptoJS.enc.Utf8);
    // }
    return entityName;
  }
  getEntityId() {
    var entityId = '';
    var key = CryptoJS.enc.Utf8.parse('1234567891012345');
    var iv = CryptoJS.enc.Utf8.parse('1234567891012345');
    if (localStorage.getItem('_entity')) {
      entityId = CryptoJS.AES.decrypt(localStorage.getItem('_entityId'), key, {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }).toString(CryptoJS.enc.Utf8);
    }
    return entityId;
  }

  formatDate(dateObject) {
    return dateObject.day + "/" + dateObject.month + "/" + dateObject.year;
  }

  public getSubdomainFromUrl(): string {
    let subDomain = "";
    const parsedUrl = new URL(window.location.href);
    const urlParts = parsedUrl.host.split('.', 1);

    if (urlParts.length > 0)
      subDomain = urlParts[0];

    return subDomain;
  }

  public removeSlashFromUrlAtEnd(url: string): string {
    if (url.charAt(url.length - 1) == '/')
      url = url.substring(0, url.length - 1);

    return url;
  }
  public getOriginFromUrl() {
    let origin = "";
    const parsedUrl = new URL(window.location.href);
    const urlParts = parsedUrl.origin;
    if (urlParts.length > 0)
      origin = urlParts;
    return origin;
  }
  public formatBytes(bytes, decimals = 2) {
    if (!+bytes) return '0 Bytes'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
  }

  calculateSeclectedfilterCount(pageFilterList: any[], requestModel: any) {
    let count = 0;
    pageFilterList.forEach(element => {
      switch (element.type) {
        case 'text':
        case 'select':
        case 'checkBox':
        case 'date':
          if (requestModel[element.fromControl]) count++;
          break;
        case 'multiSelect':
          if (requestModel[element.fromControl]?.length > 0) count++;
          break;
        case 'dateRange':
          if (requestModel[element.toDate] && requestModel[element.fromDate]) count++;
          break;
      }
    });
    return count;
  }

  // getEntityName(): string {
  //   var entityName = '';
  //   var key = CryptoJS.enc.Utf8.parse('1234567891012345');
  //   var iv = CryptoJS.enc.Utf8.parse('1234567891012345');
  //   if (localStorage.getItem('_entity')) {
  //     entityName = CryptoJS.AES.decrypt(localStorage.getItem('_entity'), key, {
  //       keySize: 128 / 8,
  //       iv: iv,
  //       mode: CryptoJS.mode.CBC,
  //       padding: CryptoJS.pad.Pkcs7
  //     }).toString(CryptoJS.enc.Utf8);
  //   }
  //   return entityName;
  // }
  // Utility function to convert base64 to blob
  base64ToBlob(base64Image: string, contentType: string) {
    const base64Data = base64Image.split(',')[1];
    const byteCharacters = atob(base64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  }
  formatString(template: string, ...values: string[]): string {
    return values.reduce((str, value, index) => str.replace(`{${index}}`, value), template);
  }
  formatToDDMMYYYY(date: any): string {
    if (date != undefined && date != null) {
      const day = String(date.day).padStart(2, '0');
      const month = String(date.month).padStart(2, '0');
      const year = date.year;
 
      return `${day}/${month}/${year}`;
    }
    else {
      return "";
    }
  };
}
